/**
 * Quizzes con rúbrica: cada opción lleva `points` (0–maxPoints).
 * El incremento del acumulado del grupo (`group.score`) es proporcional a `maxGameDelta`
 * (por defecto 100 pts de rúbrica → +10 pt al marcador, alineado con un acierto pleno en quiz clásico).
 */

/**
 * @param {number} points
 * @param {number} [maxPoints=100]
 * @param {number} [maxGameDelta=10]
 * @returns {number} delta de puntuación (una decimal como mucho)
 */
export function rubricPointsToScoreDelta(points, maxPoints = 100, maxGameDelta = 10) {
	const p = Number(points);
	const maxP = Number(maxPoints);
	if (!Number.isFinite(p) || !Number.isFinite(maxP) || maxP <= 0) return 0;
	const clamped = Math.max(0, Math.min(maxP, p));
	const raw = (clamped / maxP) * maxGameDelta;
	return Math.round(raw * 10) / 10;
}

/**
 * @param {Array<{ points?: unknown }>} options
 * @returns {boolean}
 */
export function quizOptionsAreWeighted(options) {
	return (
		Array.isArray(options) &&
		options.length > 0 &&
		options.every((o) => typeof o.points === "number" && Number.isFinite(o.points))
	);
}
